export default __webpack_public_path__ + "./fonts/uncheckedMenu.6635066d.svg";